import { memo } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
// Import UI Components
import { Button, Tooltip } from '@geneui/components';
// Import Components
import BlockedBySubscriptionInfo from 'components/common/BlockedBySubscriptionInfo';
// Import Constants
import { l, ActionsIcons, BLOCKED_BY_SUBSCRIPTION_CLASSNAME } from 'constants/common';

const ClientActionsButtons = ({ data, manageTagAction, isBlocked }) => {
    const { t } = useTranslation();

    return (
        <BlockedBySubscriptionInfo isBlocked={isBlocked}>
            <div
                className={classNames({
                    [`${BLOCKED_BY_SUBSCRIPTION_CLASSNAME} cursor-default background-unset`]: isBlocked,
                })}
            >
                <Tooltip text={t(l.ManageTag)}>
                    <Button
                        icon={ActionsIcons.ManageTag}
                        appearance="minimal"
                        color="primary"
                        onClick={isBlocked ? noop : () => manageTagAction(data)}
                    />
                </Tooltip>
            </div>
        </BlockedBySubscriptionInfo>
    );
};

ClientActionsButtons.propTypes = {
    data: PropTypes.object.isRequired,
    isBlocked: PropTypes.bool,
    manageTagAction: PropTypes.func,
};

ClientActionsButtons.defaultProps = {
    manageTagAction: noop,
};

export default memo(ClientActionsButtons);
